import {Injectable} from '@angular/core';
import {HttpService} from './http.service';
import {of} from 'rxjs';
import {mergeMap} from 'rxjs/operators';

export enum PROPERTY_STATUS {
    DEV_ADMIN = 3,
    DEV_MANAGER = 4,
    DEV_EMPLOYEE = 5
}
/**
 * @class ProjectService
 * @description This is a service which control projects data globally
 */
@Injectable({
  providedIn: 'root'
})

export class ProjectService {
  projects = [];

  constructor(private httpService: HttpService) {
  }

  getAllSimpleProjectsByUser() {
    if (this.projects && this.projects.length > 0) {
      return of(this.projects);
    } else {
      return this.httpService.getAllSimpleProjectsByUser().pipe(
        mergeMap((res: any) => {
          console.log(res,'getAllSimpleProjectsByUser')
          if (res.code === 1) {
            console.log(res);
            this.projects = res.data;
            return of(this.projects);
          } else {
            console.log('cannot get projects');
          }
        })
      );
    }
  }
}
